/* ============================================================
   EUTEYIA - Bannière cookies maison (conforme CNIL/RGPD)
   Branchée sur l'API Customer Privacy de Shopify.
   MODE TEST : ne s'affiche que si l'URL contient ?eutcookie=test
   (tant que LIVE=false). Passer LIVE=true pour la prod
   APRES avoir desactive l'app Consentmo.
   ============================================================ */
(function () {
  "use strict";

  /* ===== CONFIG ===== */
  var LIVE = true; // <-- true pour activer en production
  var TEST = /[?&]eutcookie=test/i.test(location.search);
  if (!LIVE && !TEST) return;

  var PRIVACY_URL = "/policies/privacy-policy";

  if (document.getElementById("eutck-root")) return;

  /* ===== STYLES (mobile-first : bottom sheet pleine largeur ; desktop : carte bas-gauche) ===== */
  var css =
    "#eutck-root *{box-sizing:border-box;font-family:inherit}" +
    "#eutck-banner{display:none;position:fixed;left:0;right:0;bottom:0;z-index:2147483000;width:100%;background:#fff;color:#151515;border-top:1px solid #efefef;border-radius:0;box-shadow:0 -10px 40px rgba(0,0,0,.10);padding:18px 20px calc(18px + env(safe-area-inset-bottom));font-size:14px;line-height:1.5;animation:eutckIn .35s cubic-bezier(.2,.8,.2,1)}" +
    "@keyframes eutckIn{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:none}}" +
    "#eutck-banner h3{margin:0 0 8px;font-size:13.5px;font-weight:500;letter-spacing:.03em;text-transform:uppercase;color:#1a1a1a}" +
    "#eutck-banner p{margin:0 0 12px;color:#5f5f5f;font-size:13px}" +
    "#eutck-banner a{color:#151515;text-decoration:underline}" +
    ".eutck-row{display:flex;flex-direction:column;gap:10px}" +
    ".eutck-btn{width:100%;border:1px solid #151515;border-radius:0;padding:13px 12px;font-size:14px;font-weight:600;cursor:pointer;text-align:center;background:#fff;color:#151515;transition:opacity .15s}" +
    ".eutck-btn--fill{background:#151515;color:#fff}" +
    ".eutck-btn:hover{opacity:.82}" +
    ".eutck-manage{display:block;width:100%;margin-top:12px;background:none;border:0;color:#8a8a8a;font-size:12px;text-decoration:underline;cursor:pointer;text-align:center}" +
    "#eutck-prefs{margin-top:16px;border-top:1px solid #eee;padding-top:8px}" +
    "#eutck-prefs.eutck-hide{display:none}" +
    ".eutck-line{display:flex;align-items:center;justify-content:space-between;gap:14px;padding:10px 0}" +
    ".eutck-line b{font-size:13px;font-weight:600;display:block;margin-bottom:1px}" +
    ".eutck-line small{font-size:11px;color:#9a9a9a}" +
    ".eutck-sw{position:relative;width:42px;height:24px;flex:0 0 auto}" +
    ".eutck-sw input{opacity:0;width:0;height:0;position:absolute}" +
    ".eutck-sw i{position:absolute;inset:0;background:#dcdcdc;border-radius:24px;transition:.2s}" +
    ".eutck-sw i:before{content:'';position:absolute;height:20px;width:20px;left:2px;top:2px;background:#fff;border-radius:50%;transition:.2s;box-shadow:0 1px 3px rgba(0,0,0,.25)}" +
    ".eutck-sw input:checked + i{background:#151515}" +
    ".eutck-sw input:checked + i:before{transform:translateX(18px)}" +
    ".eutck-sw input:disabled + i{opacity:.45}" +
    /* ---- DESKTOP : carte discrète en bas à gauche façon Lunifia ---- */
    "@media(min-width:640px){" +
    "#eutck-banner{left:0;right:auto;bottom:0;width:560px;border:1px solid #ececec;border-left:0;border-bottom:0;border-radius:0;box-shadow:0 -6px 40px rgba(0,0,0,.12);padding:20px 30px 22px}" +
    ".eutck-row{flex-direction:row;gap:8px}" +
    ".eutck-btn{width:auto;flex:1;padding:11px 10px;font-size:13px}" +
    "}";

  var style = document.createElement("style");
  style.textContent = css;
  document.head.appendChild(style);

  /* ===== DOM ===== */
  var root = document.createElement("div");
  root.id = "eutck-root";
  root.innerHTML =
    '<div id="eutck-banner" role="dialog" aria-label="Consentement aux cookies">' +
      "<h3>On respecte ta vie privée 🤍</h3>" +
      "<p>On utilise des cookies pour faire tourner le site, mesurer l'audience et personnaliser les pubs. Tu choisis. " +
      '<a href="' + PRIVACY_URL + '">Politique de confidentialité</a>.</p>' +
      '<div class="eutck-row">' +
        '<button class="eutck-btn" data-eutck="reject">Tout refuser</button>' +
        '<button class="eutck-btn eutck-btn--fill" data-eutck="accept">Tout accepter</button>' +
      "</div>" +
      '<button class="eutck-manage" data-eutck="toggle">Gérer mes préférences</button>' +
      '<div id="eutck-prefs" class="eutck-hide">' +
        '<div class="eutck-line"><span><b>Nécessaires</b><small>Panier, compte, sécurité. Toujours actifs</small></span>' +
          '<label class="eutck-sw"><input type="checkbox" checked disabled><i></i></label></div>' +
        '<div class="eutck-line"><span><b>Mesure d\'audience</b><small>Analyse anonyme du trafic</small></span>' +
          '<label class="eutck-sw"><input type="checkbox" data-eutck-cat="analytics"><i></i></label></div>' +
        '<div class="eutck-line"><span><b>Publicité</b><small>Pubs personnalisées (Meta, Google...)</small></span>' +
          '<label class="eutck-sw"><input type="checkbox" data-eutck-cat="marketing"><i></i></label></div>' +
        '<div class="eutck-row" style="margin-top:10px">' +
          '<button class="eutck-btn eutck-btn--fill" data-eutck="save">Enregistrer mes choix</button>' +
        "</div>" +
      "</div>" +
    "</div>";
  document.body.appendChild(root);

  var banner = root.querySelector("#eutck-banner");
  var prefs = root.querySelector("#eutck-prefs");

  function showBanner() { banner.style.display = "block"; }
  function hideBanner() { banner.style.display = "none"; }
  function openPrefs() { prefs.classList.remove("eutck-hide"); showBanner(); }
  window.eutckOpenCookies = openPrefs;

  /* ===== API Shopify Customer Privacy ===== */
  function withAPI(cb) {
    if (window.Shopify && Shopify.customerPrivacy) { cb(true); return; }
    if (window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) {
        cb(!err && !!(window.Shopify && Shopify.customerPrivacy));
      });
    } else { cb(false); }
  }

  function setConsent(analytics, marketing) {
    withAPI(function (ok) {
      if (!ok) return;
      try {
        Shopify.customerPrivacy.setTrackingConsent(
          { analytics: !!analytics, marketing: !!marketing, preferences: !!analytics, sale_of_data: !!marketing },
          function () {}
        );
      } catch (e) {}
    });
  }

  /* ===== Actions ===== */
  root.addEventListener("click", function (e) {
    var t = e.target.closest("[data-eutck]");
    if (!t) return;
    var a = t.getAttribute("data-eutck");
    if (a === "accept") { setConsent(true, true); hideBanner(); }
    else if (a === "reject") { setConsent(false, false); hideBanner(); }
    else if (a === "toggle") { prefs.classList.toggle("eutck-hide"); }
    else if (a === "save") {
      var an = root.querySelector('[data-eutck-cat="analytics"]').checked;
      var mk = root.querySelector('[data-eutck-cat="marketing"]').checked;
      setConsent(an, mk); hideBanner();
    }
  });
  /* ===== Reouverture discrete (conforme RGPD : on peut toujours changer d'avis) =====
     Pas de bouton flottant. Un lien "Cookies" est glisse dans le menu legal du footer,
     + n'importe quel element [data-eutck-open] ou lien vers #cookies rouvre le panneau. */
  document.addEventListener("click", function (e) {
    var o = e.target.closest && e.target.closest('[data-eutck-open], a[href="#cookies"]');
    if (o) { e.preventDefault(); openPrefs(); }
  });
  function injectFooterLink() {
    if (document.getElementById("eutck-footer-link")) return;
    var ref = document.querySelector('a[href*="/policies/"]');
    var ul = ref && ref.closest("ul");
    if (!ul) return;
    var li = document.createElement("li");
    var a = document.createElement("a");
    a.id = "eutck-footer-link";
    a.href = "#cookies";
    a.textContent = "Cookies";
    a.setAttribute("data-eutck-open", "");
    li.appendChild(a);
    ul.appendChild(li);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", injectFooterLink);
  else injectFooterLink();
  setTimeout(injectFooterLink, 1500);
  setTimeout(injectFooterLink, 4000);

  /* ===== Affichage initial =====
     On n'affiche QUE si aucun choix n'a encore ete enregistre.
     (shouldShowBanner() de Shopify reste bloque a true meme apres un choix
     dans cette config -> on se fie a l'existence d'un consentement stocke.) */
  function hasChosen(c) {
    c = c || {};
    return [c.marketing, c.analytics, c.preferences, c.sale_of_data]
      .some(function (v) { return v === "yes" || v === "no"; });
  }
  withAPI(function (ok) {
    var show = TEST;
    if (ok && !TEST) {
      try {
        show = Shopify.customerPrivacy.shouldShowBanner() &&
               !hasChosen(Shopify.customerPrivacy.currentVisitorConsent());
      } catch (e) { show = false; }
    }
    if (show) showBanner(); else hideBanner();
    if (ok) {
      try {
        var c = Shopify.customerPrivacy.currentVisitorConsent() || {};
        var an = root.querySelector('[data-eutck-cat="analytics"]');
        var mk = root.querySelector('[data-eutck-cat="marketing"]');
        if (an) an.checked = c.analytics === "yes" || c.analytics === true;
        if (mk) mk.checked = c.marketing === "yes" || c.marketing === true;
      } catch (e) {}
    }
  });
})();
